/**
 * Layout helpers for shifting downstream node chains when a node expands/collapses.
 */

export function getDescendantNodeIds(sourceId, edges) {
  const childrenBySource = {}

  for (const edge of edges || []) {
    if (!edge?.source || !edge?.target) continue
    if (!childrenBySource[edge.source]) {
      childrenBySource[edge.source] = []
    }
    childrenBySource[edge.source].push(edge.target)
  }

  const descendants = new Set()
  const queue = [...(childrenBySource[sourceId] || [])]

  while (queue.length > 0) {
    const id = queue.shift()
    if (descendants.has(id)) continue
    descendants.add(id)
    for (const childId of childrenBySource[id] || []) {
      queue.push(childId)
    }
  }

  return descendants
}

export function measureNodeBottom(nodeId, reactFlowInstance, nodes) {
  const node = nodes.find((n) => n.id === nodeId)
  if (!node?.position) return 0

  const nodeEl =
    typeof document !== 'undefined'
      ? document.querySelector(`[data-id="${nodeId}"]`)
      : null

  if (nodeEl && reactFlowInstance?.screenToFlowPosition) {
    const rect = nodeEl.getBoundingClientRect()
    return reactFlowInstance.screenToFlowPosition({
      x: rect.left + rect.width / 2,
      y: rect.bottom,
    }).y
  }

  const expanded = node.data?.expanded !== false
  const estimatedHeight =
    node.measured?.height ||
    node.height ||
    (expanded ? 120 : 80)

  return node.position.y + estimatedHeight
}

export function shiftDescendantPositions(nodes, sourceId, deltaY, edges) {
  if (!deltaY || Math.abs(deltaY) < 1) {
    return nodes
  }

  const descendantIds = getDescendantNodeIds(sourceId, edges)
  if (descendantIds.size === 0) {
    return nodes
  }

  return nodes.map((node) => {
    if (!descendantIds.has(node.id)) {
      return node
    }

    return {
      ...node,
      position: {
        ...node.position,
        y: node.position.y + deltaY,
      },
    }
  })
}
